module.exports = __webpack_public_path__ + "static/media/salesanalyst.99df7c87.jpg";